import { api } from "./api";
import { getTypedocByKey } from "./components/Layout/Workdoc/typedoc";

const classesWithExtTypes = ["tracker"];

export default class Binding {
  constructor(binding) {
    this.debug = api.debug;

    if (binding && typeof binding === "object") {
      Object.assign(this, binding);
      this.url = this.makeUrl();
      this.iconClass = this.makeIconClass();
      if (classesWithExtTypes.includes(binding.classcode)) {
        this.typedoc = getTypedocByKey(binding.typecode);
      } else {
        this.typedoc = getTypedocByKey(binding.classcode);
      }
    } else {
      this.error("Некорректный binding в конструкторе");
    }
  }
  error(message) {
    if (this.debug) {
      console.error("binding.js ERROR:", message);
    }
  }
  makeUrl() {
    let url = "";
    switch (this.classcode) {
      case "template":
        if (this.statetypecode === "disabled") {
          url = `/workdoc/add/any/${this.id}/`;
        } else {
          url = `/manual/all/${this.id}/`;
        }
        break;
      case "element":
        url = `/element/${this.ship || "any"}/${this.specification || "any"}/${
          this.id
        }`;
        break;
      case "maintenance":
        url = `/maint/${this.structure || "any"}/${this.id}`;
        break;
      case "instruction":
        url = `/manual/all/${this.id}/`;
        break;
      case "workdoc":
        url = `/workdoc/default/any/${this.id}/`;
        break;
      case "staff":
        url = `/staff/${this.id}/`;
        break;
      case "waybill":
        url = `/workdoc/any/any/${this.id}/`;
        break;
      case "installation":
        url = `/workdoc/any/any/${this.id}/`;
        break;
      case "cancellation":
        url = `/workdoc/any/any/${this.id}/`;
        break;
      case "troubleshooting":
        url = `/workdoc/any/any/${this.id}/`;
        break;
      case "order":
        url = `/workdoc/any/any/${this.id}/`;
        break;
      case "request":
        url = `/workdoc/any/any/${this.id}/`;
        break;
      case "repair":
        url = `/workdoc/any/any/${this.id}/`;
        break;
      case "undertake":
        url = `/workdoc/any/any/${this.id}/`;
        break;
      case "tracker":
        url = `/tracker/all/${this.id}/`;
        break;
      case "journal":
        url = `/journal/any/${this.id}/`;
        break;
      case "model":
        url = `/model/any/${this.id}/`;
        break;
      case "bunker":
        url = `/bunkerorder/${this.id}/`;
        break;
      case "product":
        if (this.storage) {
          url = `/product/${this.storage}/`;
        }
        break;
      default:
        url = false;
    }

    return url;
  }
  makeIconClass() {
    let iconClass = "";

    switch (this.classcode) {
      case "instruction":
        iconClass = "fa fa-file-text-o text-dark-50";
        break;
      case "template":
        iconClass = "fa fa-file-code-o text-muted";
        break;
      case "workdoc":
        iconClass = "fa fa-file-text text-muted";
        break;
      case "staff":
        iconClass = "fa fa-user-o text-muted";
        break;
      default:
        iconClass = "fa fa-file-o text-dark-50";
        break;
    }

    return iconClass;
  }
}
